module.exports = __webpack_public_path__ + "img/20200704_131708.562a8acf.jpg";